export const translations = {
  sv: {
    nav: {
      home: "HEM",
      services: "TJÄNSTER",
      projects: "PROJEKT",
      contact: "KONTAKT",
    },
    services: {
      photo: "FLYGFOTO",
      video: "VIDEOPRODUKTION",
      images360: "360 BILDER",
      surfaceModels: "YTMODELLER",
      models3d: "3D MODELLER",
      orthophotos: "ORTOFOTON",
      volumeCalculations: "VOLYMBERÄKNINGAR",
      inspections: "INSPEKTIONER",
      measurements: "INMÄTNINGAR",
      visualization: "VISUALISERING",
    },
    hero: {
      title: "Effektiva lösningar med drönare",
      description:
        "Vi erbjuder professionella drönartjänster för alla typer av projekt. Kontakta oss för en kostnadsfri konsultation.",
      contactUs: "Kontakta oss",
    },
    about: {
      title: "Aerial Picture Studios",
      description1:
        "Vi är specialister på drönartjänster med över 10 års erfarenhet av att identifiera applikationer och leverera skräddarsydda lösningar till våra kunder. Sedan starten 2015 har vi haft en tydlig vision: att ligga i framkant när det gäller innovation, pris och kvalitet. Därför arbetar vi med modern, diversifierad utrustning som kan anpassas efter både budget och behov.",
      description2:
        "Vi innehar alla nödvändiga tillstånd och försäkringar som krävs för att flyga drönare och tar alltid hänsyn till regler och risker. Vi finns i Stockholm och Linköping men utför uppdrag över hela landet. Du är alltid välkommen att kontakta oss för att bolla idéer!",
    },
    serviceCards: {
      photo: {
        title: "FLYGFOTO",
        description:
          "Med bilder från drönare får du ett helt nytt perspektiv. Fastigheter är ett utmärkt motiv att skildra från ovan. Bilder från balkonghöjder för att visa utsikten redan innan en byggnad är uppförd är ett bra användningsområde. Eller varför inte göra ett fotomontage för att visa hur planerad bebyggelse passar in i landskapet?",
      },
      video: {
        title: "VIDEOPRODUKTION",
        description:
          "Behöver ni en säljande film för en fastighet eller ett varumärke? Med videoklipp både från marken från luften får filmen en häftig känsla. Vi kan producera en hel film från början till slut med klippning musik och grafik. Vi kan även leverera flygfilm till en större produktion som vill ha ett unikt perspektiv.",
      },
      inspections: {
        title: "INSPEKTIONER",
        description:
          "Höghöjdsinspektion är ofta dyrt, svårt och ibland farligt men med drönare blir det enkelt och effektivt. Skorstenar, master, kraftledningar, broar, fastigheter och industrier är exempel på perfekta objekt för drönarinspektion. Leveransen kan vara bilder, film, 3D modeller eller högupplösta och mätbara ortofoton över fasader och tak.",
      },
      surfaceModels: {
        title: "YTMODELLER",
        description:
          "Vi kan leverera ortofoton, ytmodeller och höjdkurvor med hög noggrannhet. Ortofoton från drönare ger en betydligt högre detaljrikedom än Lantmäteriets kartor. När det kommer till ytmodeller kan vi ta fram både DTM och DSM. Konturlinjer kan tas fram med önskade höjdintervaller och användas i CAD-program.",
      },
      models3d: {
        title: "3D MODELLER",
        description:
          "Vi kan leverera 3D-modeller och punktmoln. Punktmolnen kan klassificeras med avancerade algoritmer för att exempelvis ta bort vegetation. 3D modeller kan användas till solstudier och visualisering i olika sammanhang. En 3D modell av en fastighet kan även kompletteras med laserskanning av insidan för att skapa en digital tvilling.",
      },
      volumeCalculations: {
        title: "VOLYMBERÄKNINGAR",
        description:
          "Företag med stora inventarier kan dra nytta av att enkelt kunna göra noggranna volymberäkningar. Oavsett om det handlar om flis, stockhögar eller bergtäkter har vi smarta lösningar. Vi kan leverera ett inmätt punktmoln där kunden får tillgång direkt över webben och kan ta mått.",
      },
    },
    modelShowcase: {
      title: "3D modeller direkt i webbläsaren",
      loadModel: "Ladda 3D-modell",
      viewMore: "Se fler 3D-modeller",
    },
    projects: {
      readMore: "Se projektet",
      purpose: "SYFTE",
      facts: "FAKTA",
      delivery: "LEVERANS",
      client: "KUND",
      blaiken: {
        title: "BLAIKENGRUVAN",
        purpose:
          "Syftet med uppdraget var att ta fram underlag för en pågående miljöåtgärd i Blaikengruvan i Sorsele kommun. Kunden ville bland annat göra beräkningar av olika slag samt simulera hur vattennivån i dagbrottet ändrade sig givet en viss vattenmängd.",
        facts: {
          area: "Område: 460 hektar",
          resolution: "Upplösning: 3 cm/pixel",
          accuracy: "Noggrannhet: ca 4 cm",
          flightSupport: "Inmätta flygstöd: Ja",
          coordinates: "Koordinatsystem: SWEREF 99TM",
        },
      },
    },
    facts: {
      area: "Område",
      resolution: "Upplösning",
      accuracy: "Noggrannhet",
      flightSupport: "Inmätta flygstöd",
      coordinates: "Koordinatsystem",
    },
    testimonials: {
      title: "Vad våra kunder säger",
      customer: "privatkund",
    },
    references: {
      title: "Våra kunder",
    },
    footer: {
      about: {
        title: "OM OSS",
        text: "Vi är specialister på drönartjänster och har över 10 års erfarenhet av att identifiera användningsområden och ta fram lösningar till kunder. Vi innehar alla nödvändiga tillstånd och försäkringar som krävs för att flyga drönare och tar alltid hänsyn till regler och risker.",
      },
      info: {
        title: "INFO",
        address: "Adress",
        postAddress: "Postadress",
        email: "Email",
        phone: "Tel",
      },
    },
  },

  en: {
    nav: {
      home: "HOME",
      services: "SERVICES",
      projects: "PROJECTS",
      contact: "CONTACT",
    },
    services: {
      photo: "AERIAL PHOTOGRAPHY",
      video: "VIDEO PRODUCTION",
      images360: "360 IMAGES",
      surfaceModels: "SURFACE MODELS",
      models3d: "3D MODELS",
      orthophotos: "ORTHOPHOTOS",
      volumeCalculations: "VOLUME CALCULATIONS",
      inspections: "INSPECTIONS",
      measurements: "MEASUREMENTS",
      visualization: "VISUALIZATION",
    },
    hero: {
      title: "Effective Drone Solutions",
      description:
        "We offer professional drone services for all types of projects. Contact us for a free consultation.",
      contactUs: "Contact Us",
    },
    about: {
      title: "Aerial Picture Studios",
      description1:
        "We are specialists in drone services with many years of experience in identifying applications and developing solutions for customers. We started in 2015 with the vision of being at the forefront when it comes to innovation, price, and quality. Our equipment is therefore modern and diversified to adapt to the customer's budget and needs.",
      description2:
        "We hold all necessary permits and insurances required to fly drones and always take regulations and risks into account. We are based in Stockholm and Linköping but carry out assignments throughout the country. You are always welcome to contact us to discuss ideas!",
    },
    serviceCards: {
      photo: {
        title: "AERIAL PHOTOGRAPHY",
        description:
          "With drone images you get a completely new perspective. Properties are an excellent subject to capture from above. Images from balcony heights to show the view before a building is constructed is a great use case. Or why not create a photomontage to show how planned development fits into the landscape?",
      },
      video: {
        title: "VIDEO PRODUCTION",
        description:
          "Need a promotional film for a property or brand? With video clips from both ground and air, the film gets an impressive feel. We can produce an entire film from start to finish with editing, music, and graphics. We can also deliver aerial footage to a larger production that wants a unique perspective.",
      },
      inspections: {
        title: "INSPECTIONS",
        description:
          "High-altitude inspection is often expensive, difficult, and sometimes dangerous, but with drones, it becomes simple and efficient. Chimneys, masts, power lines, bridges, properties, and industries are examples of perfect objects for drone inspection. Delivery can be images, film, 3D models, or high-resolution and measurable orthophotos of facades and roofs.",
      },
      surfaceModels: {
        title: "SURFACE MODELS",
        description:
          "We can deliver orthophotos, surface models, and contour lines with high accuracy. Drone orthophotos provide significantly higher detail than Lantmäteriet maps. When it comes to surface models, we can produce both DTM and DSM. Contour lines can be generated with desired height intervals and used in CAD programs.",
      },
      models3d: {
        title: "3D MODELS",
        description:
          "We can deliver 3D models and point clouds. Point clouds can be classified with advanced algorithms to, for example, remove vegetation. 3D models can be used for solar studies and visualization in various contexts. A 3D model of a property can also be complemented with laser scanning of the interior to create a digital twin.",
      },
      volumeCalculations: {
        title: "VOLUME CALCULATIONS",
        description:
          "Companies with large inventories can benefit from being able to easily make accurate volume calculations. Whether it's wood chips, log piles, or quarries, we have smart solutions. We can deliver a measured point cloud where the customer gets access directly via the web and can take measurements.",
      },
    },
    modelShowcase: {
      title: "3D models directly in the browser",
      loadModel: "Load 3D Model",
      viewMore: "View More 3D Models",
    },
    projects: {
      readMore: "View project details",
      purpose: "PURPOSE",
      facts: "FACTS",
      delivery: "DELIVERY",
      client: "CLIENT",
      blaiken: {
        title: "BLAIKEN STORUMAN",
        purpose:
          "The purpose of the assignment was to provide documentation for an ongoing environmental measure at the Blaiken mine in Sorsele municipality. The client wanted to make various calculations and simulate how the water level in the open pit changed given a certain amount of water.",
        facts: {
          area: "Location: 460 hectares",
          resolution: "Resolution: 3 cm/pixel",
          accuracy: "Accuracy: approx. 4 cm",
          flightSupport: "Measured flight support: Yes",
          coordinates: "Coordinate system: SWEREF 99TM",
        },
      },
    },
    facts: {
      area: "Location",
      resolution: "Resolution",
      accuracy: "Accuracy",
      flightSupport: "Measured flight support",
      coordinates: "Coordinate System",
    },
    testimonials: {
      title: "What Our Customers Say",
      customer: "private customer",
    },
    references: {
      title: "Our Customers",
    },
    footer: {
      about: {
        title: "ABOUT US",
        text: "We are specialists in drone services with many years of experience in identifying applications and developing solutions for customers. We hold all necessary permits and insurance required to fly drones and always take regulations and risks into account.",
      },
      info: {
        title: "INFO",
        address: "Address",
        postAddress: "Postal Address",
        email: "Email",
        phone: "Phone",
      },
    },
  },
};
